<template>
  <div class="absolute min-h-full min-w-full grid place-items-center">
    <slot></slot>
  </div>
</template>
